import {useEffect, useState} from 'react';
import {useGlobals} from '../../../../../globalPropsContext';

export function useWishlist(productId: string) {
  const {userWishlistMap, handleWishlistToggle} = useGlobals();
  const [inWishlist, setInWishlist] = useState(false);

  useEffect(() => {
    const isInWishlist = userWishlistMap?.[productId] === true;
    setInWishlist(isInWishlist);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [userWishlistMap?.[productId], productId]);

  const toggleWishlist = () => {
    setInWishlist((prev) => !prev);
    void handleWishlistToggle(productId, !inWishlist);
  };

  return {inWishlist, toggleWishlist};
}
